// extracted by mini-css-extract-plugin
module.exports = {"selectionType":"CourseSettingsToggles_selectionType_1FbF9"};